export enum NetworkTypes {
  EVM = 'evm',
  MEMO = 'memo',
  TVM = 'tvm',
  BIP32 = 'bip32',
  SOLANA = 'solana',
  MONERO = 'monero',
  CARDANO = 'cardano',
}
export type NetworkType = (typeof NetworkTypes)[keyof typeof NetworkTypes]
export const networkTypeList = Object.values(NetworkTypes) as [NetworkType, ...NetworkType[]]

export const blockStatuses = {
  pending: 'pending',
  finalized: 'finalized',
  uncled: 'uncled',
} as const

export type BlockStatus = (typeof blockStatuses)[keyof typeof blockStatuses]
export const blockStatusList = Object.values(blockStatuses) as [BlockStatus, ...BlockStatus[]]
